import { Toast, Tooltip } from './_bootstrap';
//Components
import "./menu";

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));
    
  (function ($, Drupal) {
    Drupal.behaviors.varios = {
      attach: function attach(context, settings) {
        let logo = "/themes/custom/ceranium/logo.svg";
        let logobw = "/themes/custom/ceranium/logo_bw.svg";
        function logoScroll() {
          if ($(document).scrollTop() == 0) {
            $("#navbar-principal").addClass("scrolltop");
            $("#navbar-principal .navbar-brand img").attr("src", logobw);
          } else {
            $("#navbar-principal").removeClass("scrolltop");
            $("#navbar-principal .navbar-brand img").attr("src", logo);
          }
        }
        if(logo.length > 0){
          logoScroll();
          $(window).on("scroll", function () {
            logoScroll();
          });
        }
      }
    };
    Drupal.behaviors.youtubeLoop = {
      attach: function (context, settings) {
        // Cargar la API de YouTube solo una vez
        if (!window.YT) {
          var tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
  
        window.onYouTubeIframeAPIReady = function () {
          var player = new YT.Player('youtube-player', {
            events: {
              'onStateChange': function (event) {
                if (event.data === YT.PlayerState.ENDED) {
                  player.seekTo(0); // Reinicia el video cuando termine
                }
              }
            }
          });
        };
      }
    };
  })(jQuery, Drupal)
})();


